import axios, { AxiosError } from 'axios';
import { parseAxiosError } from '../common/constant';
import { BASEURL, LEAVE_MANAGEMENT_URL } from './const';
import moment from 'moment';

const controllers: Record<string, AbortController> = {};

/* HTTP Request Interceptor to add headers on all API calls */
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    Promise.reject(error);
  }
)

export const createNewFolder = async (payload: any) => {
  try {
    const response = await axios.post(`${BASEURL}/folder`, payload);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const getFolders = async (userId: string) => {
  try {
    const response = await axios.get(`${BASEURL}/folder/${userId}`);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const getNotesByFolder = async (folderId: string, userId: string) => {
  try {
    const response = await axios.get(`${BASEURL}/notes/${folderId}/${userId}`);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const createNewNote = async (payload: any) => {
  try {
    if (controllers[payload?.folderId]) {
      controllers[payload?.folderId].abort();
    }
    controllers[payload?.folderId] = new AbortController();

    const response = await axios.post(`${BASEURL}/notes`, payload, {
      signal: controllers[payload?.folderId].signal,
    });
    return response?.data;
  } catch (error: any) {
    if (axios.isCancel(error)) {
      console.log(`Update for note ${payload?.folderId} was canceled.`);
    }
    return parseAxiosError(error as AxiosError);
  }
}

export const updateNote = async (noteId:string, payload: any) => {
  try {
    if (controllers[noteId]) {
      controllers[noteId].abort();
    }
    controllers[noteId] = new AbortController();

    const response = await axios.put(`${BASEURL}/notes/${noteId}`, payload, {
      signal: controllers[noteId].signal,
    });

    return response?.data;
  } catch (error: any) {
    if (axios.isCancel(error)) {
      console.log(`Update for note ${noteId} was canceled.`);
    }
    return parseAxiosError(error as AxiosError);
  }
}

export const getContentByNoteId = async (payload: any) => {
  try {
    const response = await axios.post(`${BASEURL}/notes/getNoteContent`, payload);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const updateFolderName = async (folderId:string, payload: any) => {
  try {
    const response = await axios.put(`${BASEURL}/folder/${folderId}`, payload);

    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const updateContentByNoteId = async (payload: any) => {
  try {
    const response = await axios.post(`${BASEURL}/notes/updateNoteContent`, payload);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const deleteFolder = async (folderId: any) => {
  try {
    const response = await axios.delete(`${BASEURL}/folder/${folderId}`);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const deleteNote = async (noteId: any) => {
  try {
    const response = await axios.delete(`${BASEURL}/notes/${noteId}`);
    return response?.data;
  } catch (error: any) {
    return parseAxiosError(error as AxiosError);
  }
}

export const uploadFile = async (userId: string, folderName: string, fileDetails: FormData): Promise<any> => {
  try {
      const response = await axios.post(`${BASEURL}/uploadFile/?userId=${userId}&folderName=${folderName}`, fileDetails);
      return response?.data;
  } catch (error: any) {
      return parseAxiosError(error as AxiosError);
  }
}